import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Corporate from "./Corporate";
import AccountHolders from "./AccountHolders";
import AccountDetails from "./AccountDetails";
import GBPComponent from "./GBPComponent";
import AccountHealth from "./AccountHealth";
import OverDueNextDue from "./OverDueNextDue";
import InstructionSetCard from "./InstructionSet";
import RecentTransactions from "./RecentTransactions";
import QuickActionsCard from "./QuickActions";
import { useSelector } from "react-redux";
import useLoanDetails from "./useLoanDetails";
import "./CSSStylesheet.css";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
import AchPopup, {
  AchAlertModal,
  AchSetupModal,
  TaxFormModal,
  TaxInfoModal,
} from "./AchPopup";
import useAchData from "../BankAccountACHPayments/useAchData";

function LDPBorrowerForDemo() {
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showTaxInfo, setShowTaxInfo] = useState(false);
  const [showAchForm, setShowAchForm] = useState(false);
  const [showAchAlert, setShowAchAlert] = useState(() =>
    sessionStorage.getItem("achAlert")
      ? JSON.parse(sessionStorage.getItem("achAlert"))
      : false
  );

  const loanId = useSelector((state) => state.account.lenderId);
  // const loanId = "776423838E6B446485452E4178903687";
  // const loanId = "D83E5562F5EF4CA98CD1FD2887633AB3";
  const { data } = useLoanDetails(loanId);
  const { fetchACHData, achData, loading } = useAchData();

  const achAlert = JSON.parse(sessionStorage.getItem("achAlert"));

  useEffect(() => {
    if (loanId) {
      fetchACHData(loanId);
    }
  }, [loanId]);

  useEffect(() => {
    if (achData?.length) {
      const show = achData[0].DISABLE_YN.toLowerCase() === "n" ? true : false;
      setShowTaxForm(show);
    }
  }, [achData?.length, achAlert]);

  return (
    <div>
      {!loading ? (
        <Container fluid style={{ marginBottom: "1.5rem" }}>
          <Row className="g-2">
            {data?.kpi?.[0] ? (
              <Col sm={12} md={12} lg={3}>
                <Corporate account_details={data?.account_details} />
                <AccountHolders Account_Holder={data?.account_holder} />
                <AccountDetails property_details={data?.property_details} />
              </Col>
            ) : (
              <Col sm={12} md={12} lg={3}>
                <div>
                  <SpinnerBlock />
                </div>
              </Col>
            )}
            <Col sm={12} lg={9}>
              <Row>
                <Col>
                  <GBPComponent kpi={data?.kpi} />
                </Col>
              </Row>
              <Row>
                {data?.kpi?.[0] ? (
                  <Col xs={12} sm={6} md={6}>
                    {" "}
                    {/* Flex container for equal height */}
                    <div className="card-container">
                      <AccountHealth
                        InsuranceDetails={data?.insurance_details}
                        style={{ marginLeft: "5px" }}
                      />
                      <InstructionSetCard
                        instruction_set_details={data?.instruction_set_details}
                      />
                      <QuickActionsCard />
                      {/* <RecentTransactions style={{ marginLeft: "5px" }} /> */}
                    </div>
                  </Col>
                ) : (
                  <Col xs={12} sm={6} md={6}>
                    <div>
                      <SpinnerBlock />
                    </div>
                  </Col>
                )}
                <Col xs={12} sm={6} md={6} className="d-flex flex-column h-100">
                  <div className="card-container d-flex flex-column h-100">
                    <div className="flex-grow-1 d-flex flex-column">
                      <OverDueNextDue overdueNextDue={data?.overdue_nextdue} />
                    </div>
                    {/* Optionally add other fixed-height components below */}
                    {/* <RecentTransactions /> */}
                  </div>
                </Col>
                {/* <Col xs={6} md={2}></Col> */}
              </Row>
              {/* <Row>
              <Col xs={12} md={5}>
                {/* <QuickActionsCard /> 
              </Col>
              <Col xs={12} md={5}>
                {/* <RecentTransactions /> 
              </Col>
              <Col xs={6} md={2}></Col>
            </Row> */}
            </Col>
          </Row>
          <TaxFormModal
            show={showTaxForm}
            setShow={setShowTaxForm}
            setShowTaxInfo={setShowTaxInfo}
          />

          <TaxInfoModal
            show={showTaxInfo}
            setShow={setShowTaxInfo}
            setShowAchAlert={setShowAchAlert}
            achCondition={true}
          />
          <AchAlertModal
            show={showAchAlert}
            setShow={setShowAchAlert}
            setShowAchSetup={setShowAchForm}
          />
          <AchSetupModal show={showAchForm} setShow={setShowAchForm} />
        </Container>
      ) : (
        <div>
          <SpinnerBlock height="50vh" />
        </div>
      )}
    </div>
  );
}

export default LDPBorrowerForDemo;
